import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { startTelegram } from './shared/telegram/index.js';
import { App } from './app/app.js';
import './app/global.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App runtime={startTelegram()} />
  </StrictMode>,
);
